export type IColourPresetSet = "light" | "normal" | "dark";

const LIGHT_PRESETS = [
    "#f1e7f8", "#eae8fd", "#e5edfc", "#e5f3f3",
    "#e7f4eb", "#ebf6e8", "#f2f7e0", "#fdf3e0",
    "#fdeee0", "#fce6e6", "#ececec", "#e0e0e0",
];

const NORMAL_PRESETS = [
    "#a061d1", "#7166f0", "#5484ed", "#50b1b1",
    "#5eb57d", "#78c464", "#a6cc33", "#f2b033",
    "#f28b33", "#ed5555", "#7f7f7f", "#333333",
];

const DARK_PRESETS = [
    "#704492", "#4f47a8", "#3b5ca6", "#387c7c",
    "#427f58", "#548946", "#748f24", "#a97b24",
    "#a96124", "#a63c3c", "#595959", "#242424",
];

export const ColourPickerPresets: Record<IColourPresetSet, string[]> = {
    light: LIGHT_PRESETS,
    normal: NORMAL_PRESETS,
    dark: DARK_PRESETS,
};
